<div class="filters" [formGroup]="filtersForm">
  @if (showOrganizationFilter) {
    <app-input-multiselect
      placeholder="Organization"
      i18n-placeholder="@@filters.organization"
      [options]="filterOptions.organizations"
      [group]="true"
      optionLabel="label"
      optionValue="value"
      formControlName="organizationIds"
      [touched]="filtersForm.get('organizationIds')?.touched"
      [errorMessage]="filtersForm.get('organizationIds')?.errors"
      [filter]="true"
      [maxSelectedLabels]="1"
    >
    </app-input-multiselect>
  }

  <app-input-multiselect
    placeholder="Reported By"
    i18n-placeholder="@@filters.reportedBy"
    [options]="filterOptions.accounts"
    [group]="true"
    optionLabel="label"
    optionValue="value"
    formControlName="reportedByIds"
    [touched]="filtersForm.get('reportedByIds')?.touched"
    [errorMessage]="filtersForm.get('reportedByIds')?.errors"
    [filter]="true"
    [maxSelectedLabels]="1"
  >
  </app-input-multiselect>

  <app-input-multiselect
    placeholder="Identification"
    i18n-placeholder="@@filters.identification"
    [options]="filterOptions.identifications"
    [group]="true"
    optionLabel="label"
    optionValue="value"
    formControlName="possibleIdentifications"
    [touched]="filtersForm.get('possibleIdentifications')?.touched"
    [errorMessage]="filtersForm.get('possibleIdentifications')?.errors"
    [filter]="true"
    [maxSelectedLabels]="1"
  >
  </app-input-multiselect>

  <app-input-multiselect
    placeholder="Status"
    i18n-placeholder="@@filters.status"
    [options]="filterOptions.statuses"
    optionLabel="label"
    optionValue="value"
    formControlName="statuses"
    [touched]="filtersForm.get('statuses')?.touched"
    [errorMessage]="filtersForm.get('statuses')?.errors"
    [maxSelectedLabels]="1"
  >
  </app-input-multiselect>
</div>